export const EXPENSE_LOADING = 'EXPENSE_LOADING';
export const EXPENSE_FULFILLED = 'EXPENSE_FULFILLED';
export const EXPENSES_FULFILLED = 'EXPENSES_FULFILLED';
